import React from 'react';
import { useOptimizedKeywordTracking } from '../../pages/NewKeywordTrackingUI/OptimizedKeywordTrackingUIContainer';
import PlatformTabs from '../Common/PlatformTabs';

const OptimizedKeywordFilterTabs = () => {
  const { activeTab, setActiveTab, searchFilters } = useOptimizedKeywordTracking();

  // Derive the visually active tab: if the user applied a platform filter via
  // the FilterPanel, that platform should be highlighted rather than the
  // lastly-clicked tab. Fall back to activeTab when no filter platform is set.
  const filterPlatform = searchFilters?.platform
    ? (Array.isArray(searchFilters.platform) ? searchFilters.platform[0] : searchFilters.platform)
    : null;
  const effectiveActiveTab = filterPlatform || activeTab;

  return <PlatformTabs activeTab={effectiveActiveTab} onChange={setActiveTab} variant="pill" />;
};

export default OptimizedKeywordFilterTabs;
